import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import styles from "./Priority.module.css";
import { useTranslation } from "@coworker/locales";

type PriorityProps = {
  dim?: boolean | undefined;
};

function Priority({ dim = false }: PriorityProps) {
  const { t } = useTranslation();

  return (
    <FixaStatus
      data-testid={"priority"}
      variant={dim ? "indeterminate" : "negative"}
      label={t("priorityString")}
      small
      className={styles["root"]}
    />
  );
}

export default Priority;
